import { setupCountUp } from "@/js/helpers";

const setupFloatingHideOnFooter = () => {
    const floating = document.querySelector(".pg-member-merit-floating");
    const footer = document.querySelector(".l-footer-wrapper");
    if (!floating || !footer) return;

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                floating.classList.toggle("is-hidden", entry.isIntersecting);
            });
        },
        { rootMargin: "0px 0px 0px 0px", threshold: 0 },
    );

    observer.observe(footer);
};

const memberMerit = () => {
    setupCountUp(".pg-member-merit-portal__row-to em");
    setupCountUp(".pg-member-merit-award__google-count-num em");
    setupCountUp(".pg-member-merit-award__portal-big-num");
    setupCountUp(".pg-member-merit-award__portal-count em");
    setupCountUp(".pg-member-merit-award__reviews-stat em");
    setupCountUp(".pg-member-merit-award__legacy-stat em");
    setupFloatingHideOnFooter();
};

export default memberMerit;
